<nz-descriptions nzTitle="Partners" [style.margin-bottom]="'15px'" nzLayout="vertical">
  <nz-descriptions-item nzTitle="Mould Developers">
    <em-error-result
      [subTitle]="errorMsg"
      *ngIf="error$ | async as errorMsg; else resultOrLoadingTpl"
    ></em-error-result>
  </nz-descriptions-item>

  <ng-template #resultOrLoadingTpl>
    <nz-spin *ngIf="isLoading$ | async; else result" nzSimple></nz-spin>
  </ng-template>

  <ng-template #result>
    <ng-container>
      <em-display-property
        [value]="partnersTpl"
        [templateIsEmpty]="!(partners ?? [] | arrayIsNotEmpty)"
      ></em-display-property>
      <ng-template #partnersTpl>
        <nz-tag *ngFor="let partner of partners; trackBy: trackByRef">
          {{ partner.partner }}
        </nz-tag>
      </ng-template>
    </ng-container>
  </ng-template>
</nz-descriptions>
